// extracted by mini-css-extract-plugin
module.exports = {"wrapperMain":"ShortcutPinSection_wrapperMain__2Xg9G","box":"ShortcutPinSection_box__hZyv_"};